import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";

import usePrivateLink from "../config/usePrivateLink";

import { LoadingDiv, SweetAlertShow, closeModal } from "../master/Master";

import {
  collectionDistributionItemsList,
  collectionDistributionItemAdd,
  collectionDistributionItemUpdate,
  collectionDistributionItemDelete,
  collectionDistributionItemStatusChange,
  collectionDistributionCategoriesList,
} from "../../api/CollectionDistribution";
import { useNavigate } from "react-router-dom";

export default function Items() {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);

  const [modelData, setModelData] = useState({});

  const getItems = async () => {
    setLoading(true);

    try {
      const response = await collectionDistributionItemsList();

      if (response?.data?.status) {
        setItems(response?.data?.data || []);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getCategories = async () => {
    try {
      const response = await collectionDistributionCategoriesList();

      if (response?.data?.status) {
        setCategories(response?.data?.data || []);
      }
    } catch (error) {}
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await collectionDistributionItemAdd(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        e.target.reset();

        closeModal("addItem");

        getItems();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await collectionDistributionItemUpdate(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        closeModal("updateItem");

        getItems();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);

    try {
      const response = await collectionDistributionItemDelete(id);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        getItems();
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id) => {
    setLoading(true);

    try {
      const response = await collectionDistributionItemStatusChange(id);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        getItems();
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    getCategories();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-3">
                <div className="row">
                  <Master />

                  <div className="col-md-10">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="text-primary m-0">Items</h4>

                          {hasAccess("/collections/distribution/item/add") && (
                            <button
                              className="btn btn-primary btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#addItem"
                            >
                              <i className="bi bi-plus-circle me-2"></i>
                              Add Item
                            </button>
                          )}
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover table-bordered text-center align-middle">
                            <thead className="table-primary">
                              <tr>
                                <th>#</th>
                                <th>Category</th>
                                <th>Item Name</th>
                                <th>Code</th>
                                <th>Distribution</th>
                                <th>Payment</th>
                                <th>Amount</th>
                                <th>Stock</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {items?.length > 0 ? (
                                items?.map((item, i) => (
                                  <tr key={item?.id}>
                                    <td>{i + 1}</td>

                                    <td>{item?.category?.category_name}</td>

                                    <td>{item?.item_name}</td>

                                    <td>{item?.item_code}</td>

                                    <td>
                                      <span className="badge bg-label-primary">
                                        {item?.distribution_type}
                                      </span>
                                    </td>

                                    <td>
                                      <span className="badge bg-label-info">
                                        {item?.payment_type}
                                      </span>
                                    </td>

                                    <td>₹ {item?.amount}</td>

                                    <td>{item?.stock_quantity}</td>

                                    <td>
                                      <span
                                        className={`badge ${
                                          item?.status === "1"
                                            ? "bg-success"
                                            : "bg-danger"
                                        }`}
                                      >
                                        {item?.status === "1"
                                          ? "Active"
                                          : "Inactive"}
                                      </span>
                                    </td>

                                    <td>
                                      <div className="d-flex justify-content-center gap-2">
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={item?.status === "1"}
                                            onChange={() =>
                                              handleStatusChange(item?.id)
                                            }
                                          />
                                        </div>
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() =>
                                            navigate(
                                              `/collections/distribution/item/fields?item_id=${item?.id}`,
                                            )
                                          }
                                        >
                                          <i className="ri-list-settings-line"></i>
                                        </button>

                                        <button
                                          className="btn btn-sm btn-outline-info"
                                          data-bs-toggle="modal"
                                          data-bs-target="#updateItem"
                                          onClick={() => setModelData(item)}
                                        >
                                          <i className="ri-edit-line"></i>
                                        </button>

                                        <button
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "This item will be deleted.",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonText: "Yes Delete",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                handleDelete(item?.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="ri-delete-bin-line"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="10">No Items Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ADD ITEM */}

      <div className="modal fade" id="addItem" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleAdd}>
              <div className="modal-header bg-label-primary">
                <h5 className="modal-title">Add Item</h5>

                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Category</label>

                    <select className="form-select" name="category_id" required>
                      <option value="">Select Category</option>

                      {categories?.map((cat) => (
                        <option value={cat?.id} key={cat?.id}>
                          {cat?.category_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Item Name</label>

                    <input
                      type="text"
                      className="form-control input-uppercase"
                      name="item_name"
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Item Code</label>

                    <input
                      type="text"
                      className="form-control"
                      name="item_code"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Distribution Type</label>

                    <select className="form-select" name="distribution_type">
                      <option value="Permanent">Permanent</option>

                      <option value="Returnable">Returnable</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Payment Type</label>

                    <select className="form-select" name="payment_type">
                      <option value="Free">Free</option>

                      <option value="Paid">Paid</option>

                      <option value="Partial">Partial</option>

                      <option value="Sponsored">Sponsored</option>
                    </select>
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label">Amount</label>

                    <input
                      type="number"
                      className="form-control"
                      name="amount"
                      defaultValue={0}
                    />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label">Stock Quantity</label>

                    <input
                      type="number"
                      className="form-control"
                      name="stock_quantity"
                      defaultValue={0}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Description</label>

                    <textarea
                      className="form-control input-uppercase"
                      rows={3}
                      name="description"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="modal-footer bg-label-primary">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* UPDATE ITEM */}

      <div
        className="modal fade"
        id="updateItem"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleUpdate}>
              <div className="modal-header bg-label-primary">
                <h5 className="modal-title">Update Item</h5>

                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  <input type="hidden" name="id" value={modelData?.id || ""} />

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Category</label>

                    <select
                      className="form-select"
                      name="category_id"
                      defaultValue={modelData?.category_id}
                    >
                      {categories?.map((cat) => (
                        <option value={cat?.id} key={cat?.id}>
                          {cat?.category_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Item Name</label>

                    <input
                      type="text"
                      className="form-control input-uppercase"
                      name="item_name"
                      defaultValue={modelData?.item_name}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Item Code</label>

                    <input
                      type="text"
                      className="form-control"
                      name="item_code"
                      defaultValue={modelData?.item_code}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Distribution Type</label>

                    <select
                      className="form-select"
                      name="distribution_type"
                      defaultValue={modelData?.distribution_type}
                    >
                      <option value="Permanent">Permanent</option>

                      <option value="Returnable">Returnable</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Payment Type</label>

                    <select
                      className="form-select"
                      name="payment_type"
                      defaultValue={modelData?.payment_type}
                    >
                      <option value="Free">Free</option>

                      <option value="Paid">Paid</option>

                      <option value="Partial">Partial</option>

                      <option value="Sponsored">Sponsored</option>
                    </select>
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label">Amount</label>

                    <input
                      type="number"
                      className="form-control"
                      name="amount"
                      defaultValue={modelData?.amount}
                    />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label">Stock Quantity</label>

                    <input
                      type="number"
                      className="form-control"
                      name="stock_quantity"
                      defaultValue={modelData?.stock_quantity}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Description</label>

                    <textarea
                      className="form-control input-uppercase"
                      rows={3}
                      name="description"
                      defaultValue={modelData?.description}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="modal-footer bg-label-primary">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
